<template>
  <div class="NotFound-wrap" :class="{ content: isElectron }">
    <div class="content-wrap">
      <img src="../../assets/images/404.png" alt="" />
      <p class="tips">抱歉，您访问的页面不存在</p>
      <p class="link-list">
        <router-link class="default-btn" :to="{ name: 'Home' }"
          >返回官网</router-link
        >
        <router-link class="primary-btn" :to="{ name: 'myCourse' }"
          >去学习中心</router-link
        >
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isElectron: window.isElectron,
    };
  },
  mounted() {
    console.log("log", this.$route);
  },
};
</script>
<style lang="scss" scoped>
.content.NotFound-wrap {
  background: transparent;
  height: 100%;
}
.NotFound-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 50px;
  background: #fff;
  min-height: calc(100vh - 300px);
  img {
    width: 200px;
  }
  .tips {
    font-weight: 400;
    font-size: 14px;
    color: #0d1400;
    line-height: 20px;
  }
  .content-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .link-list {
    display: flex;
    margin-top: 30px;
    color: $saas-theme-color;
    & > a {
      margin-right: 16px;
    }
    & > a:last-child {
      margin-right: 0;
    }
  }
  .default-btn,
  .primary-btn {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .default-btn {
    width: 100px;
    height: 36px;
    border-radius: 8px;
    background: #f7f8f9;
    font-weight: 400;
    font-size: 14px;
    color: #0d1400;
    line-height: 22px;
  }
  .primary-btn {
    width: 100px;
    height: 36px;
    border-radius: 8px;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    font-weight: 600;
    font-size: 14px;
    color: #ffffff;
    line-height: 22px;
  }
}
@media (max-width: 767px) {
  .NotFound-wrap {
    min-height: calc(100vh - #{$h5-footer-height});
    width: 100%;
    img {
      width: 200px;
      height: auto;
    }
    .link-list {
      margin-top: 0.53rem;
      & > a {
        margin-right: 0.4rem;
      }
    }
  }
}
</style>
